export const PERMISSIONS = {
  // 1. AI Credits
  AI_CREDITS: 'ai_credits',
  USAGE_READ: 'usage:read',
  
  // 2. Project Settings
  PROJECT_SETTINGS_READ: 'project_settings:read',
  PROJECT_SETTINGS_WRITE: 'project_settings:write',
  
  // 3. Integrations
  INTEGRATIONS_READ: 'integrations:read',
  INTEGRATIONS_WRITE: 'integrations:write',
  
  // 4. Add Site
  ADD_SITE: 'add_site',
  
  // 5. Project Dashboard
  VIEW_PROJECT: 'view_project',
  OPEN_DASHBOARD: 'open_dashboard',
  DESIGN_EDITOR: 'design_editor',
  PREVIEW: 'preview',
  
  // 6. Duplicate
  DUPLICATE_PROJECT: 'duplicate_project',
  
  // 7. Transfer Project
  TRANSFER_PROJECT: 'transfer_project',
  
  // 8. Team Settings
  TEAM_SETTINGS: 'team_settings',
  TEAM_SETTINGS_READ: 'team_settings:read',
  
  // 9. Domain
  DOMAIN_READ: 'domain:read',
  DOMAIN_WRITE: 'domain:write',
  
  // 10. Purchase Domain
  PURCHASE_DOMAIN: 'purchase_domain',

  // 11. WordPress
  WORDPRESS_READ: 'wordpress:read',
  WORDPRESS_WRITE: 'wordpress:write',
  
  
  // 12. Workspace Settings/Delete
  WORKSPACE_SETTINGS: 'workspace_settings',
  WORKSPACE_SETTINGS_READ: 'workspace_settings:read',
  DELETE_WORKSPACE: 'delete_workspace',
  BILLING_READ: 'billing:read',
  
  // 13. Site Settings
  SITE_SETTINGS_READ: 'site_settings:read',
  SITE_SETTINGS_WRITE: 'site_settings:write',
  ADD_GUEST: 'add_guest',
  
  // 14. Upgrade Now
  UPGRADE_NOW: 'upgrade_now',
  
  // 15. Publish
  PUBLISH: 'publish',
  PUBLISH_READ: 'publish:read',
  
  // 16. Pages
  PAGES_READ: 'pages:read',
  PAGES_WRITE: 'pages:write',
  
  // 17. Components
  COMPONENTS_READ: 'components:read',
  COMPONENTS_WRITE: 'components:write',
  
  // 18. Forms
  FORMS_READ: 'forms:read',
  FORMS_WRITE: 'forms:write',
  
  // 19. Contacts
  CONTACTS_READ: 'contacts:read',
  CONTACTS_WRITE: 'contacts:write',
  
  // 20. Orders
  ORDERS_READ: 'orders:read',
  ORDERS_WRITE: 'orders:write',
  
  // 21. Products
  PRODUCTS_READ: 'products:read',
  PRODUCTS_WRITE: 'products:write',

  // 22. Blog
  BLOG_READ: 'blog:read',
  BLOG_WRITE: 'blog:write',
}

export const ROLE_PERMISSIONS = {
  owner: [
    ...Object.values(PERMISSIONS),
  ],
  
  admin: [
    ...Object.values(PERMISSIONS),
  ],
  
  member: [
    PERMISSIONS.AI_CREDITS,
    PERMISSIONS.USAGE_READ,
    PERMISSIONS.PROJECT_SETTINGS_READ,
    PERMISSIONS.PROJECT_SETTINGS_WRITE,
    PERMISSIONS.INTEGRATIONS_READ,
    PERMISSIONS.INTEGRATIONS_WRITE,
    PERMISSIONS.ADD_SITE,  
    PERMISSIONS.VIEW_PROJECT,
    PERMISSIONS.OPEN_DASHBOARD,
    PERMISSIONS.DESIGN_EDITOR,
    PERMISSIONS.PREVIEW,    
    PERMISSIONS.DUPLICATE_PROJECT,
    PERMISSIONS.TEAM_SETTINGS_READ,
    PERMISSIONS.DOMAIN_READ,
    PERMISSIONS.DOMAIN_WRITE,
    PERMISSIONS.WORDPRESS_READ,
    PERMISSIONS.WORDPRESS_WRITE,
    PERMISSIONS.WORKSPACE_SETTINGS_READ,
    PERMISSIONS.SITE_SETTINGS_READ,
    PERMISSIONS.SITE_SETTINGS_WRITE,
    PERMISSIONS.ADD_GUEST,
    PERMISSIONS.PUBLISH,
    PERMISSIONS.PUBLISH_READ,
    PERMISSIONS.PAGES_READ,
    PERMISSIONS.PAGES_WRITE,
    PERMISSIONS.COMPONENTS_READ,
    PERMISSIONS.COMPONENTS_WRITE,
    PERMISSIONS.FORMS_READ,
    PERMISSIONS.FORMS_WRITE,
    PERMISSIONS.CONTACTS_READ,
    PERMISSIONS.CONTACTS_WRITE,
    PERMISSIONS.ORDERS_READ,
    PERMISSIONS.ORDERS_WRITE,
    PERMISSIONS.PRODUCTS_READ,
    PERMISSIONS.PRODUCTS_WRITE,
    PERMISSIONS.BLOG_READ,
    PERMISSIONS.BLOG_WRITE,
  ],

  viewer: [
    PERMISSIONS.AI_CREDITS,
    PERMISSIONS.USAGE_READ,
    PERMISSIONS.PROJECT_SETTINGS_READ,
    PERMISSIONS.INTEGRATIONS_READ,
    PERMISSIONS.VIEW_PROJECT,
    PERMISSIONS.OPEN_DASHBOARD,
    PERMISSIONS.DESIGN_EDITOR,
    PERMISSIONS.PREVIEW,
    PERMISSIONS.TEAM_SETTINGS_READ,
    PERMISSIONS.DOMAIN_READ,
    PERMISSIONS.WORDPRESS_READ,
    PERMISSIONS.WORKSPACE_SETTINGS_READ,
    PERMISSIONS.SITE_SETTINGS_READ,
    PERMISSIONS.PUBLISH_READ,
    PERMISSIONS.PAGES_READ,
    PERMISSIONS.COMPONENTS_READ,
    PERMISSIONS.FORMS_READ,
    PERMISSIONS.CONTACTS_READ,
    PERMISSIONS.ORDERS_READ,
    PERMISSIONS.PRODUCTS_READ,
    PERMISSIONS.BLOG_READ,
  ],
}

export function getPermissionsForRole(role) {
  if (!role) return []
  const normalizedRole = role.toLowerCase()
  return ROLE_PERMISSIONS[normalizedRole] || []
}

export function roleHasPermission(role, permission) {
  const permissions = getPermissionsForRole(role)
  return permissions.includes(permission)
}

export function roleHasAnyPermission(role, permissions) {
  const rolePerms = getPermissionsForRole(role)
  return permissions.some(perm => rolePerms.includes(perm))
}

export function roleHasAllPermissions(role, permissions) {
  const rolePerms = getPermissionsForRole(role)
  return permissions.every(perm => rolePerms.includes(perm))
}

